import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider, CSSReset } from "@chakra-ui/core";

import Firebase, { FirebaseContext } from './util/Firebase';

ReactDOM.render(<ThemeProvider>
    <CSSReset/>
    <link href='https://fonts.googleapis.com/css?family=Montserrat&display=swap' rel="stylesheet"/>
        <FirebaseContext.Provider value={new Firebase()}>
            <App/>
        </FirebaseContext.Provider>
    </ThemeProvider>, document.getElementById('root'));

            
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();